/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'generic_person_icon': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<defs><clipPath id="svgicon_generic_person_icon_a"><path pid="0" _fill="none" d="M0 0h40v40H0z"/></clipPath></defs><g clip-path="url(#svgicon_generic_person_icon_a)"><g data-name="Ellipse 305" _fill="#f4f5f7" _stroke="#c9ccd2"><circle pid="1" cx="20" cy="20" r="20" _stroke="none"/><circle pid="2" cx="20" cy="20" r="19.5" _fill="none"/></g><path pid="3" data-name="Union 1" d="M11.038 29.038v-2.255c0-2.481 4.058-4.51 9.019-4.51s9.019 2.029 9.019 4.51v2.254zm4.509-13.528a4.509 4.509 0 114.51 4.509 4.51 4.51 0 01-4.51-4.509z" _fill="#c9ccd2"/></g>'
  }
})
